__turbopack_context__.v({
  "backdrop": "CustomModal-module___O4pAa__backdrop",
  "dialog": "CustomModal-module___O4pAa__dialog",
  "modal": "CustomModal-module___O4pAa__modal",
});
